import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { InquiryService } from '../../../services/inquiry.service';
import { MaterialModule } from '../../../material.module';
import { ModalSnackbarService } from '../../../services/modal-snackbar.service';
import { FileUtilsService } from '../../../services/file-utils.service';
import { MatRadioModule } from '@angular/material/radio';
import { AbstractInquiryCreateComponent } from '../../abstract-inquiry-create.component';

@Component({
  selector: 'app-withdrawal-create',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    MatRadioModule
  ],
  templateUrl: './withdrawal-create.component.html',
  styleUrls: ['./withdrawal-create.component.scss']
})
export class WithdrawalCreateComponent extends AbstractInquiryCreateComponent {

  constructor(
    fb: FormBuilder,
    service: InquiryService,
    snackBar: ModalSnackbarService,
    fileUtils: FileUtilsService
  ) {
    super(fb, service, snackBar, fileUtils);

    this.form = this.fb.group({
      acc: ['', [Validators.required, Validators.maxLength(50)]],
      method: ['', Validators.required],
      amount: [''],
      bank_name: ['', [Validators.required, Validators.maxLength(50)]],
      bank_branch: ['', [Validators.required, Validators.maxLength(50)]],
      branch_number: ['', [Validators.required, Validators.maxLength(50)]],
      acc_type: ['', Validators.required],
      acc_number: ['', [Validators.required, Validators.maxLength(50)]],
      holder_type: ['', Validators.required],
      overseas: ['', Validators.maxLength(400)],
      body: ['',Validators.maxLength(400)],
      files: [[], [this.fileUtils.fileSizeValidator(20 * 1024 * 1024), this.fileUtils.minFileCountValidator(1)]] // 20MB
    });
  }

  submit() {
    if (this.form.invalid) return;

    const formData = new FormData();

    const body = `出資口座番号 : ${this.form.value.acc}
ご出金方法 : ${this.form.value.method}
一部出金の出金額 : ${this.form.value.amount}

送金先銀行名 : ${this.form.value.bank_name}
本店・支店名 : ${this.form.value.bank_branch}
本店・支店名番号 : ${this.form.value.branch_number}

口座種別 : ${this.form.value.acc_type}
口座番号 : ${this.form.value.acc_number}
口座名義種別 : ${this.form.value.holder_type}

海外銀行の場合 : ${this.form.value.overseas}

補足 : ${this.form.value.body}`;

    let title = this.form.value.acc + ' ・ ' + this.form.value.method;
    if (this.form.value.amount > 0) {
      title += ' ・ ' + this.form.value.amount;
    }

    formData.append('category', '出金依頼');
    formData.append('title', title);
    formData.append('child[body]', body);

    this.form.value.files.forEach((file: File, i: number) => {
      formData.append(`attachments[]`, file, file.name);
    });

    this.service.uploadWithFile(formData).subscribe({
      next: () => {
        this.snackBar.show('出金依頼を作成しました', '/withdrawal');
      },
      error: () => {
        this.snackBar.show('作成に失敗しました');
      }
    });
  }
}
